import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    className: 'feedback-viewer-pin-comment',

    events: {
        'click': 'openPin'
    },

    dom_handlers: {
        openPin: function(e) {
            if (UI.isMobile()) {
                $('body').toggleClass('feedback-viewer-show-details');
            }

            if (this.$el.hasClass('open')) {
                this.close();
            } else {
                this.open();
            }
        },

        dragStart: function(x, y, e) {
            e.stopPropagation();

            if (!this.canEdit()) {
                return;
            }

            this.start_screen_x = this.model.get('screen_x');
            this.start_screen_y = this.model.get('screen_y');
            this.start_start_x  = this.model.get('start_x');
            this.start_start_y  = this.model.get('start_y');

            var stroke_size = 4;
            var canvas_el = $('.annotation-canvas');

            this.min_dx = Math.min(this.start_start_x, this.start_screen_x) * this.screenshot_data.zoom / 100 * -1 + stroke_size / 2;
            this.min_dy = Math.min(this.start_start_y, this.start_screen_y) * this.screenshot_data.zoom / 100 * -1 + stroke_size / 2;
            this.max_dx = canvas_el.width()  - Math.max(this.start_start_x, this.start_screen_x) * this.screenshot_data.zoom / 100 - stroke_size / 2;
            this.max_dy = canvas_el.height() - Math.max(this.start_start_y, this.start_screen_y) * this.screenshot_data.zoom / 100 - stroke_size / 2;
        },

        dragMove: function(dx, dy, x, y, e) {
            e.stopPropagation();

            if (!this.canEdit()) {
                return;
            }

            dx = Math.max(dx, this.min_dx);
            dy = Math.max(dy, this.min_dy);
            dx = Math.min(dx, this.max_dx);
            dy = Math.min(dy, this.max_dy);

            var transform_x = dx * 100 / this.screenshot_data.zoom;
            var transform_y = dy * 100 / this.screenshot_data.zoom;

            // svg redraws on modal change
            this.model.set({
                screen_x : parseInt(this.start_screen_x + transform_x, 10),
                screen_y : parseInt(this.start_screen_y + transform_y, 10),
                start_x  : parseInt(this.start_start_x + transform_x, 10),
                start_y  : parseInt(this.start_start_y + transform_y, 10)
            });
        },

        dragStop: function(e) {
            e.stopPropagation();

            if (!this.canEdit()) {
                return;
            }

            if (this.start_screen_x === this.model.get('screen_x') &&
                this.start_screen_y === this.model.get('screen_y') &&
                this.start_start_x  === this.model.get('start_x') &&
                this.start_start_y  === this.model.get('start_y')) {

                return;
            }

            // re-render without transform
            this.renderSvg();

            // save new position
            Cache.app.request({
                action: 'feedback\\comment/edit',
                data: {
                    id       : this.model.id,
                    screen_x : this.model.get('screen_x'),
                    screen_y : this.model.get('screen_y'),
                    start_x  : this.model.get('start_x'),
                    start_y  : this.model.get('start_y')
                }
            });
        }
    },

    event_handlers: {
        onThreadSelect: function(view_cid, model_id) {
            if (model_id === this.model.id) {
                this.$el.addClass('open');
            } else {
                this.$el.removeClass('open');
            }
        },

        onPinCommentOpen: function(id) {
            if (id !== this.model.id) {
                this.close();
            }
        },

        onPinCommentResolve: function() {
            this.updateResolvedStatus();
        },

        onScreenshotUpdate: function(data) {
            // data: zoom, width, height, left, top
            this.screenshot_data = {
                screenshot_num : parseInt(data.screenshot_num, 10),
                zoom           : parseInt(data.zoom, 10),
                width          : parseInt(data.width, 10),
                height         : parseInt(data.height, 10),
                top            : parseInt(data.top, 10),
                left           : parseInt(data.left, 10)
            };

            this.setPosition();
        },

        onPinCommentMove: function() {
            this.setPosition();
        }
    },

    initialize: function(options) {
        this.screenshot_data = {
            zoom   : 0,
            width  : 0,
            height : 0,
            top    : 0,
            left   : 0
        };

        this.feedback   = options.feedback; // model
        this.dispatcher = options.dispatcher;

        var _pin_comment_open  = this.event_handlers.onPinCommentOpen.bind(this);
        var _thread_select     = this.event_handlers.onThreadSelect.bind(this);
        var _screenshot_update = this.event_handlers.onScreenshotUpdate.bind(this);

        this.dispatcher.on('Pin_Comment:Open',  _pin_comment_open);
        this.dispatcher.on('Thread:Select',     _thread_select);
        this.dispatcher.on('Screenshot:Update', _screenshot_update);

        this.listenTo(this.model, 'change:is_resolved', this.event_handlers.onPinCommentResolve.bind(this));
        this.listenTo(this.model, 'change:screen_x',    this.event_handlers.onPinCommentMove.bind(this));
        this.listenTo(this.model, 'change:screen_y',    this.event_handlers.onPinCommentMove.bind(this));

        this.on('remove', function() {
            this.dispatcher.off('Pin_Comment:Open',  _pin_comment_open);
            this.dispatcher.off('Thread:Select',     _thread_select);
            this.dispatcher.off('Screenshot:Update', _screenshot_update);
        });
    },

    open: function() {
        this.$el.addClass('open');
        this.dispatcher.trigger('Pin_Comment:Open', this.model.id);
    },

    close: function() {
        this.$el.removeClass('open');
        this.dispatcher.trigger('Pin_Comment:Close', this.model.id);
    },

    show: function() {
        this.$el.addClass('active');

        if (this.svg_obj) {
            this.svg_obj.addClass('active');
        }
    },

    hide: function() {
        this.$el.removeClass('active');

        if (this.svg_obj) {
            this.svg_obj.removeClass('active');
        }
    },

    setPosition: function() {
        if (!this.screenshot_data.zoom) {
            return;
        }

        if (this.screenshot_data.screenshot_num !== this.model.get('screenshot_num')) {
            return;
        }

        var comment_x = this.model.get('screen_x');
        var comment_y = this.model.get('screen_y');

        if (this.model.get('annotation_type') === 'arrow') {
            var z_movement = 45;
            var oz = Math.sqrt((this.model.get('screen_x') - this.model.get('start_x')) * (this.model.get('screen_x') - this.model.get('start_x')) + (this.model.get('screen_y') - this.model.get('start_y')) * (this.model.get('screen_y') - this.model.get('start_y')));

            var x_movement = Math.abs(this.model.get('screen_x') - this.model.get('start_x')) / oz * z_movement;
            var y_movement = Math.abs(this.model.get('screen_y') - this.model.get('start_y')) / oz * z_movement;

            var direction_x = this.model.get('screen_x') >= this.model.get('start_x') ? 'right' : 'left';
            var direction_y = this.model.get('screen_y') >= this.model.get('start_y') ? 'down'  : 'up';

            comment_x = this.model.get('screen_x');
            comment_y = this.model.get('screen_y');

            comment_x += direction_x === 'right' ? x_movement : x_movement * -1;
            comment_y += direction_y === 'up'    ? y_movement * -1 : y_movement;
        }

        this.$el.css({
            top  : comment_y * this.screenshot_data.zoom / 100 + this.screenshot_data.top,
            left : comment_x * this.screenshot_data.zoom / 100 + this.screenshot_data.left
        });

        this.renderSvg();
    },

    updateResolvedStatus: function() {
        if (this.model.get('is_resolved')) {
            this.$el.attr('resolved', 'true');
        } else {
            this.$el.removeAttr('resolved');
        }

        this.updateResolvedStatusSvg();
    },

    updateResolvedStatusSvg: function() {
        if (!this.svg_obj) {
            return;
        }

        if (this.model.get('is_resolved')) {
            this.svg_obj.addClass('annotation-svg-resolved');
        } else {
            this.svg_obj.removeClass('annotation-svg-resolved');
        }
    },

    renderSquare: function() {
        if (!this.screenshot_data.zoom) {
            return;
        }

        var start_x = parseInt(this.model.get('start_x') * this.screenshot_data.zoom / 100, 10);
        var start_y = parseInt(this.model.get('start_y') * this.screenshot_data.zoom / 100, 10);

        var stop_x  = parseInt(this.model.get('screen_x') * this.screenshot_data.zoom / 100, 10);
        var stop_y  = parseInt(this.model.get('screen_y') * this.screenshot_data.zoom / 100, 10);

        var x = Math.min(start_x, stop_x);
        var y = Math.min(start_y, stop_y);
        var w = Math.abs(stop_x - start_x);
        var h = Math.abs(stop_y - start_y);

        if (this.svg_obj) {
            this.svg_obj.attr({
                x      : x,
                y      : y,
                width  : w,
                height : h
            });
        } else {
            this.svg_obj = this.snap.rect(x, y, w, h, 3, 3);

            this.svg_obj.attr({
                'stroke'           : 'rgb(230, 0, 0)',
                'stroke-width'     : 4,
                'stroke-linecap'   : 'round',
                'stroke-linejoin'  : 'round',
                'fill'             : 'rgba(230, 0, 0, 0.03)',
                'opacity'          : this.model.id === '_temp' ? 0.5 : ''
            });

            this.onRenderSvg();
        }
    },

    renderArrow: function() {
        if (!this.screenshot_data.zoom) {
            return;
        }

        var start_x = parseInt(this.model.get('start_x') * this.screenshot_data.zoom / 100, 10);
        var start_y = parseInt(this.model.get('start_y') * this.screenshot_data.zoom / 100, 10);

        var stop_x  = parseInt(this.model.get('screen_x') * this.screenshot_data.zoom / 100, 10);
        var stop_y  = parseInt(this.model.get('screen_y') * this.screenshot_data.zoom / 100, 10);

        var x_length = Math.abs(stop_x - start_x);
        var y_length = Math.abs(stop_y - start_y);

        var y_amount = 40;

        if (x_length < y_amount && y_length < y_amount) {
            y_amount = Math.max(x_length, y_length);
        }

        var x_amount = y_amount / 2.5;

        var point1 = stop_x + ' ' + stop_y;
        var point2, point3, point4;
        var translate_y = 0;

        if (stop_y >= start_y) {
            point2 = (stop_x - x_amount) + ' ' + (stop_y - y_amount);
            point3 = stop_x + ' ' + (stop_y - y_amount + 5);
            point4 = (stop_x + x_amount) + ' ' + (stop_y - y_amount);
            translate_y = 8;
        } else {
            point2 = (stop_x - x_amount) + ' ' + (stop_y + y_amount);
            point3 = stop_x + ' ' + (stop_y + y_amount - 5);
            point4 = (stop_x + x_amount) + ' ' + (stop_y + y_amount);
            translate_y = -8;
        }

        var points = point1 + ',' + point2 + ',' + point3 + ',' + point4 + ',' + point1;

        var deg = Math.atan((stop_x - start_x) / (stop_y - start_y)) * 180 / Math.PI;

        // NaN
        if (!deg) {
            deg = 0;
        }

        var arrow_2_matrix = new Snap.Matrix();
        arrow_2_matrix.rotate(deg * -1, stop_x, stop_y);
        arrow_2_matrix.translate(0, translate_y);

        if (this.svg_obj) {
            this.svg_arrow_body.attr({
                x1: start_x,
                y1: start_y,
                x2: stop_x,
                y2: stop_y
            });

            this.svg_obj_arrow_top.attr({
                points: points
            });

            this.svg_obj_arrow_top.transform(arrow_2_matrix);
        } else {
            this.svg_arrow_body = this.snap.line(start_x, start_y, stop_x, stop_y);
            this.svg_arrow_body.attr({
                'stroke'          : 'rgb(230, 0, 0)',
                'stroke-width'    : 6,
                'stroke-linecap'  : 'round',
                'stroke-linejoin' : 'round'
            });

            this.svg_obj_arrow_top = this.snap.polyline(points);
            this.svg_obj_arrow_top.attr({
                fill: 'rgb(230, 0, 0)'
            });

            this.svg_obj_arrow_top.transform(arrow_2_matrix);

            this.svg_obj = this.snap.group(this.svg_arrow_body, this.svg_obj_arrow_top);

            if (this.model.id === '_temp') {
                this.svg_obj.attr({
                    opacity: 0.5
                });
            }

            this.onRenderSvg();
        }
    },

    renderSvg: function() {
        switch (this.model.get('annotation_type')) {
            case 'square':
                this.renderSquare();
                break;
            case 'arrow':
                this.renderArrow();
                break;
        }
    },

    onRenderSvg: function() {
        if (this.model.id === '_temp') {
            return;
        }

        this.svg_obj.addClass('annotation-svg');

        if (this.canEdit()) {
            this.svg_obj.attr({cursor: 'move'});
        } else {
            this.svg_obj.attr({cursor: 'default'});
        }

        this.svg_obj.drag(
            this.dom_handlers.dragMove.bind(this),
            this.dom_handlers.dragStart.bind(this),
            this.dom_handlers.dragStop.bind(this)
        );

        this.svg_obj.click(function(e) {
            e.stopPropagation();
            this.open();
        }.bind(this));

        this.svg_obj.touchend(function(e) {
            this.open();
        }.bind(this));

        this.svg_obj.mouseover(function() {
            $('.feedback-viewer').attr('dragging', 1);
        });

        this.svg_obj.mouseout(function() {
            $('.feedback-viewer').removeAttr('dragging');
        });

        // sync active state with the root element
        if (this.$el.hasClass('active')) {
            this.svg_obj.addClass('active');
        } else {
            this.svg_obj.removeClass('active');
        }

        this.updateResolvedStatusSvg();
    },

    removeAnnotation: function() {
        if (this.svg_obj) {
            this.svg_obj.remove();
        }
    },

    setSnap: function(snap) {
        this.snap = snap;
    },

    canEdit: function() {
        return Cache.real_user_id && ((this.model.get('user_id') === Cache.real_user_id) || Cache.app.isAdmin());
    },

    render: function() {
        var content = '';

        if (this.model.id !== '_temp') {
        content += '<div class="pin">' +
                        '<span>' + this.model.get('screen_number') + '</span>' +
                        '<i class="far fa-check"></i>' +
                    '</div>';
        }

        this.setPosition();
        this.updateResolvedStatus();
        this.renderSvg();

        this.$el.html(content);

        return this;
    }
});